import chiclayo from '../../assets/img/inicio_header.png'
import trujillo from '../../assets/img/trujillo.png'
import lima from '../../assets/img/lima.png'

export const destinationsListitem = [
    {
        id: 1,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Chiclayo',
        subTitle: 'Lambayeque',
        image: chiclayo,
    },
    {
        id: 2,
        tour: 'Chan Chan',
        price: '232',
        title: 'Trujillo',
        subTitle: 'La Libertad',
        image: trujillo,
    },
    {
        id: 3,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Piura',
        subTitle: 'Piura',
        image: lima,
    },
    {
        id: 4,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Sullana',
        subTitle: 'Piura',
        image: chiclayo,
    },
    {
        id: 5,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Tumbes',
        subTitle: 'Tumbes',
        image: trujillo,
    },
    {
        id: 6,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Lima',
        subTitle: 'Lima',
        image: lima,
    },
    {
        id: 7,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Nueva Camarca',
        subTitle: 'San Martin',
        image: chiclayo,
    },
    {
        id: 8,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Tarapoto',
        subTitle: 'SanMartin',
        image: trujillo,
    },
    {
        id: 9,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Moyobamba',
        subTitle: 'San Martin',
        image: lima,
    },
    {
        id: 10,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Rioja',
        subTitle: 'San Martin',
        image: chiclayo,
    },
]